export enum DistributionCategory {
    FULL_DISTRIBUTION = 'FULL_DISTRIBUTION',
    INCLUDE_ONLY_SELECTED = 'INCLUDE_ONLY_SELECTED',
    INCLUDE_ALL_EXCEPT_SELECTED = 'INCLUDE_ALL_EXCEPT_SELECTED',
    BACK_TO_BRAND_DISTRIBUTION = 'BACK_TO_BRAND_DISTRIBUTION',
}

export enum RoomDistributionCategory {
    INCLUDE_ONLY_SELECTED = 'INCLUDE_ONLY_SELECTED',
    INCLUDE_ALL_EXCEPT_SELECTED = 'INCLUDE_ALL_EXCEPT_SELECTED',
    BACK_TO_BRAND_DISTRIBUTION = 'BACK_TO_BRAND_DISTRIBUTION',
    BACK_TO_LISTING_DISTRIBUTION = 'BACK_TO_LISTING_DISTRIBUTION',
}

export enum OutletDistributionTypes {
    UNKNOWN,
    BACK_TO_LISTING_DISTRIBUTION,
    INCLUDE_ONLY_SELECTED,
    INCLUDE_ALL_EXCEPT_SELECTED,
    BACK_TO_BRAND_DISTRIBUTION,
}

export const distributionCategoryEnumMap: { [key: number]: DistributionCategory | string } = {
    [OutletDistributionTypes.BACK_TO_LISTING_DISTRIBUTION]: 'SAME_AS_LISTING',
    [OutletDistributionTypes.INCLUDE_ONLY_SELECTED]: DistributionCategory.INCLUDE_ONLY_SELECTED,
    [OutletDistributionTypes.INCLUDE_ALL_EXCEPT_SELECTED]: DistributionCategory.INCLUDE_ALL_EXCEPT_SELECTED,
    [OutletDistributionTypes.BACK_TO_BRAND_DISTRIBUTION]: DistributionCategory.BACK_TO_BRAND_DISTRIBUTION,
};

export const DistributionCategoryIndex: Record<string, number> = {
    [DistributionCategory.FULL_DISTRIBUTION]: 3,
    [DistributionCategory.INCLUDE_ALL_EXCEPT_SELECTED]: 1,
    [DistributionCategory.INCLUDE_ONLY_SELECTED]: 2,
    [DistributionCategory.BACK_TO_BRAND_DISTRIBUTION]: 4,
};
